module.exports = __webpack_public_path__ + "img/price-settings-mobile-fr.96d7f024.jpg";